<template>
  <section class="container max-w-5xl py-[91px] px-[15px] mx-auto text-center relative z-[2]">
    <div class="inline-block font-primary font-bold italic text-[14px] text-white pb-[5px] border-b-[1px] border-white mb-[15px]">
      {{ contact_title_1 }}
    </div>
    <div class="font-primary font-extrabold text-[36px] leading-[36px] text-white uppercase pb-[60px]">
      {{ contact_title_2 }}
    </div>
    <ValidationObserver ref="formObserver">
      <form v-on:submit.prevent="onSubmit">
        <div class="grid grid-cols-12 gap-[15px]">
          <div class="col-span-12 md:col-span-4">
            <ValidationProvider rules="name_required" v-slot="{ errors }">
              <input type="text" class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="name" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_1" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-mtg-medium-cyan border-mtg-medium-cyan'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 md:col-span-4">
            <ValidationProvider rules="email_required|email_valid" v-slot="{ errors }">
              <input type="email" class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="email" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_2" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-mtg-medium-cyan border-mtg-medium-cyan'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 md:col-span-4">
            <ValidationProvider rules="phone_required" v-slot="{ errors }">
              <input type="text" class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="phone" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_3" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-mtg-medium-cyan border-mtg-medium-cyan'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 md:col-span-6">
            <ValidationProvider rules="subject_required" v-slot="{ errors }">
              <input type="text" class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="subject" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_4" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-mtg-medium-cyan border-mtg-medium-cyan'">
            </ValidationProvider>
          </div>
          <div class="col-span-12 md:col-span-6">
            <ValidationProvider rules="option_required" v-slot="{ errors }">
              <select class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="option" v-bind:class="errors.length ? 'text-mtg-medium-blue border-mtg-light-green' : 'text-mtg-medium-cyan border-mtg-medium-cyan'">
                <option selected value="">{{ errors.length ? errors[0] : contact_placeholder_5 }}</option>
                <option v-for="option in contact_options_5" v-bind:value="option.value">{{ option.name }}</option>
              </select>
            </ValidationProvider>
          </div>
          <div class="col-span-12">
            <ValidationProvider rules="message_required" v-slot="{ errors }">
              <textarea rows="6" class="w-full h-full font-primary text-[13px] text-mtg-dark-cyan bg-white py-[10px] px-[15px] border-[1px] outline-none rounded-[5px]" v-model="message" v-bind:placeholder="errors.length ? errors[0] : contact_placeholder_6" v-bind:class="errors.length ? 'placeholder-mtg-medium-blue border-mtg-light-green' : 'placeholder-mtg-medium-cyan border-mtg-medium-cyan'"></textarea>
            </ValidationProvider>
          </div>
          <div class="col-span-12 flex items-center justify-end">
            <svg v-if="loading" class="animate-spin text-mtg-light-green w-[20px] h-[20px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <button type="submit" class="inline-flex items-center justify-center text-white bg-transparent border-white py-[10px] px-[30px] border-[1px] rounded-[30px] my-[5px] mx-[10px] cursor-pointer transition-all ease-in-out duration-300 hover:text-mtg-medium-blue hover:bg-mtg-light-green hover:border-mtg-medium-blue">
              <span class="font-primary text-[15px]">{{ contact_label }}</span>
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>
<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import axios from 'axios';

extend('name_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_1
});

extend('email_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_2
});

extend('email_valid', {
  ...email,
  message: window.contact_us_script_data.contact_error_3
});

extend('phone_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_4
});

extend('subject_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_5
});

extend('option_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_6
});

extend('message_required', {
  ...required,
  message: window.contact_us_script_data.contact_error_7
});

export default {
  name: 'ContactUsForm',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      wp_ajax: window.contact_us_script_data.wp_ajax,
      wp_nonce: window.contact_us_script_data.wp_nonce,
      wp_action: 'submit_contact_us_form',
      recaptcha_token: '',
      loading: false,
      contact_title_1: window.contact_us_script_data.contact_title_1,
      contact_title_2: window.contact_us_script_data.contact_title_2,
      contact_placeholder_1: window.contact_us_script_data.contact_placeholder_1,
      contact_placeholder_2: window.contact_us_script_data.contact_placeholder_2,
      contact_placeholder_3: window.contact_us_script_data.contact_placeholder_3,
      contact_placeholder_4: window.contact_us_script_data.contact_placeholder_4,
      contact_placeholder_5: window.contact_us_script_data.contact_placeholder_5,
      contact_placeholder_6: window.contact_us_script_data.contact_placeholder_6,
      contact_options_5: window.contact_us_script_data.contact_options_5,
      contact_label: window.contact_us_script_data.contact_label,
      contact_submission_succeeded: window.contact_us_script_data.contact_submission_succeeded,
      contact_submission_failed: window.contact_us_script_data.contact_submission_failed,
      name: '',
      email: '',
      phone: '',
      subject: '',
      option: '',
      message: '',
    };
  },
  methods: {
    async onSubmit () {
      await this.$recaptchaLoaded();
      this.recaptcha_token = await this.$recaptcha(this.wp_action);
      this.$refs.formObserver.validate().then(success => {
        if (success) {
          this.loading = true;
          let formData = new FormData();
          formData.append('wp_nonce', this.wp_nonce);
          formData.append('action', this.wp_action);
          formData.append('recaptcha_token', this.recaptcha_token);
          formData.append('name', this.name);
          formData.append('email', this.email);
          formData.append('phone', this.phone);
          formData.append('subject', this.subject);
          formData.append('option', this.option);
          formData.append('message', this.message);
          axios({
            method: 'POST',
            url: this.wp_ajax,
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData,
          }).then(() => {
            this.$swal('Sent', this.contact_submission_succeeded, 'success');
            this.name = this.email = this.phone = this.subject = this.option = this.message = '';
            this.$nextTick(() => {
              this.$refs.formObserver.reset();
            });
            this.loading = false;
          }).catch(() => {
            this.$swal('Error', this.contact_submission_failed, 'error');
            this.loading = false;
          });
        }
      });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
</style>
